import { createSlice } from "@reduxjs/toolkit";
import { IChalange } from "../../models/IChalange";
import {
  chalange1Image,
  chalange2Image,
  chalange3Image,
  chalange4Image,
} from "../../assets/imageMaps";

export interface ChalangesState {
  chalanges: IChalange[];
}

const initialState: ChalangesState = {
  chalanges: [
    {
      id: 1,
      image: chalange1Image,
      name: "Заброшенный склад",
      description: `Когда-то здесь кипела логистика мегакорпораций. Теперь — только ржавчина, хлам и эхо шагов тех, кто решился сразиться среди остатков былой мощи. Каждый контейнер — укрытие. Каждый угол — ловушка. Здесь выигрывает не сила, а хладнокровие.
Добро пожаловать в мертвое сердце индустриального ада.`,
    },
    {
      id: 2,
      image: chalange2Image,
      name: "Заброшенная лаборатория",
      description: `
Каждый бой здесь — как оживший кошмар техногенного мира. Эхо старых протоколов и голографических голосов доносится сквозь разрушенные капсулы и провисшие кабели. В этих стенах сражаются не только тела, но и призраки утраченного величия.
Добро пожаловать в цитадель призрачной науки, где каждое движение может стать последним.`,
    },
    {
      id: 3,
      image: chalange3Image,
      name: "заброшенный Завод киборгов",
      description: `
Однако тишина здесь обманчива. Среди теней прошлого снова зажигаются глаза. Здесь, где киборги когда-то поднимались для войны, начинается новая битва. Лишь сильнейшие смогут покинуть этот холодный саркофаг прошлого на своих ногах.
Выживет не тот, кто прочнее — а тот, кто хитрее`,
    },
    {
      id: 4,
      image: chalange4Image,
      name: "пустошь",
      description: `Когда-то это было промышленное сердце мегаполиса — теперь лишь земля, развалины заводов и силуэты обугленных небоскребов, теряющихся в радиоактивном мареве. Здесь гул ветра заменяет сирены, а каждый бой — это выживание среди песков.
Среда не прощает ошибок. Только сильнейшие выходят отсюда на своих ногах.
Добро пожаловать в Пустошь.`,
    },
  ],
};

export const chalangesSlice = createSlice({
  name: "chalangesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

// export const {  } = chalangesSlice.actions;

export default chalangesSlice.reducer;
